import "./App.css";
import { useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Home from "./pages/Home";
import CodePage from "./pages/CodePage";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ErrorPage, { errorStatus } from "./pages/ErrorPage";
import Datenschutz from "./pages/Datenschutz";
import Impressum from "./pages/Impressum";

import { LanguageProvider, LanguageSwitch, useLanguage } from "./Language";

function LegacySection({ id }) {
  const { search } = useLocation();
  return <Navigate replace to={{ pathname: "/", search, hash: `#${id}` }} />;
}

function AppLayout() {
  const { pathname } = useLocation();
  const { t } = useLanguage();
  const content = useRef(null);
  const isCodePage = pathname === "/code" || pathname.startsWith("/p/");

  useEffect(() => {
    if (
      !window.IntersectionObserver ||
      window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
    ) {
      return;
    }
    const photos = content.current.querySelectorAll("[data-reveal]");
    if (!photos.length) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 },
    );
    photos.forEach((photo) => {
      photo.classList.add("reveal-ready");
      observer.observe(photo);
    });
    return () => observer.disconnect();
  }, [pathname]);

  return (
    <div className="App">
      <a href="#main-content" className="skip-link">
        {t("Zum Inhalt")}
      </a>
      {isCodePage ? (
        <div className="page-width scan-language">
          <LanguageSwitch />
        </div>
      ) : (
        <Navbar />
      )}
      <main id="main-content" className="content" key={pathname} ref={content}>
        <ScrollToTop>
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/code" exact element={<CodePage />} />
            <Route path="/p/:id" exact element={<CodePage />} />
            <Route path="/examples" element={<LegacySection id="examples" />} />
            <Route path="/products" element={<LegacySection id="products" />} />
            <Route path="/contact" element={<LegacySection id="contact" />} />
            <Route path="/datenschutz" exact element={<Datenschutz />} />
            <Route path="/impressum" exact element={<Impressum />} />
            <Route
              path="*"
              element={<ErrorPage status={errorStatus.notFound} />}
            />
          </Routes>
        </ScrollToTop>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppLayout />
      </Router>
    </LanguageProvider>
  );
}

export default App;
